var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 8,
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.12881C2.80584 4.03246 4.55599 3.72729 6.3884 3.72729C10.1188 3.72729 13.8728 3.86366 17.5875 3.86366",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2284 1C17.0638 2.2328 19.324 3.45428 21.5124 3.85606C21.8603 3.91993 22.75 4.05698 22.9906 4.37879C23.0906 4.51257 21.5404 5.01389 21.4687 5.03788C19.6422 5.64868 17.8121 6.14326 15.9274 6.51515C14.5589 6.78517 13.1663 6.71998 11.8206 7",
    stroke: "",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDI0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDQuMTI4ODFDMi44MDU4NCA0LjAzMjQ2IDQuNTU1OTkgMy43MjcyOSA2LjM4ODQgMy43MjcyOUMxMC4xMTg4IDMuNzI3MjkgMTMuODcyOCAzLjg2MzY2IDE3LjU4NzUgMy44NjM2NiIgc3Ryb2tlPSIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTE1LjIyODQgMUMxNy4wNjM4IDIuMjMyOCAxOS4zMjQgMy40NTQyOCAyMS41MTI0IDMuODU2MDZDMjEuODYwMyAzLjkxOTkzIDIyLjc1IDQuMDU2OTggMjIuOTkwNiA0LjM3ODc5QzIzLjA5MDYgNC41MTI1NyAyMS41NDA0IDUuMDEzODkgMjEuNDY4NyA1LjAzNzg4QzE5LjY0MjIgNS42NDg2OCAxNy44MTIxIDYuMTQzMjYgMTUuOTI3NCA2LjUxNTE1QzE0LjU1ODkgNi43ODUxNyAxMy4xNjYzIDYuNzE5OTggMTEuODIwNiA3IiBzdHJva2U9IiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";